import type { HEADING_DATA, HEADING_PARAMS, HEADING_PARAMS_DEVICE } from './types'

import { DEFAULT_MARGIN, DEFAULT_PADDING, DEFAULT_WIDTH } from '../const'

const DEFAULT_HEADING_PARAMS_DEVICE = (): HEADING_PARAMS_DEVICE => ({
  hidden: false,
  textAlign: 'left',
  fontSize: { value: 12, unit: 'px' },
  fontWeight: 400,
  padding: DEFAULT_PADDING(),
  margin: DEFAULT_MARGIN(),
  width: DEFAULT_WIDTH(),
})

export const DEFAULT_HEADING_PARAMS = (): HEADING_PARAMS => ({
  mobile: DEFAULT_HEADING_PARAMS_DEVICE(),
  tablet: DEFAULT_HEADING_PARAMS_DEVICE(),
  pc: DEFAULT_HEADING_PARAMS_DEVICE(),
})

export const DEFAULT_HEADING_DATA = (): HEADING_DATA => ({
  id: null,
  classes: null,
  type: 'heading',
  tag: 'h2',
  data: {
    value: 'Lorem Ipsum',
  },
})

export const HEADINGS = () => [
  { name: 'H1', value: 'h1' },
  { name: 'H2', value: 'h2' },
  { name: 'H3', value: 'h3' },
  { name: 'H4', value: 'h4' },
  { name: 'H5', value: 'h5' },
  { name: 'H6', value: 'h6' },
  { name: 'div', value: 'div' },
  { name: 'span', value: 'span' },
  { name: 'p', value: 'p' },
]